import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import api from "../lib/api";
import PublicNav from "../components/PublicNav";
import SalesChatWidget from "../components/SalesChatWidget";

export default function BlogPost() {
  const { slug } = useParams();
  const [post, setPost] = useState(null);
  const [missing, setMissing] = useState(false);

  useEffect(() => {
    api
      .get(`/blog/${slug}`)
      .then((r) => {
        setPost(r.data);
        document.title = `${r.data.title} | Platinum 1 Certified`;
        let meta = document.querySelector('meta[name="description"]');
        if (!meta) {
          meta = document.createElement("meta");
          meta.name = "description";
          document.head.appendChild(meta);
        }
        meta.content = r.data.meta_description || "";
      })
      .catch(() => setMissing(true));
  }, [slug]);

  return (
    <div className="min-h-screen bg-white text-slate-950" data-testid="blog-post-page">
      <PublicNav />
      <article className="max-w-3xl mx-auto px-6 py-16 md:py-24">
        <Link to="/blog" data-testid="blog-back-link" className="inline-flex items-center gap-2 text-sm font-semibold text-slate-600 hover:text-orange-600">
          <ArrowLeft className="w-4 h-4" /> All articles
        </Link>
        {missing && <h1 className="font-display text-3xl font-bold mt-8">Article not found.</h1>}
        {post && (
          <>
            <div className="text-xs uppercase tracking-[0.2em] font-bold text-orange-600 mt-8">{post.published_at?.slice(0, 10)}</div>
            <h1 className="font-display text-4xl sm:text-5xl font-black tracking-tighter mt-3" data-testid="blog-post-title">{post.title}</h1>
            <p className="text-slate-600 text-lg mt-4">{post.excerpt}</p>
            <div
              className="prose-p1 mt-10 text-slate-800 leading-relaxed [&_h2]:font-display [&_h2]:text-2xl [&_h2]:font-bold [&_h2]:mt-10 [&_h2]:mb-3 [&_h3]:font-display [&_h3]:text-xl [&_h3]:font-semibold [&_h3]:mt-8 [&_h3]:mb-2 [&_p]:my-4 [&_ul]:list-disc [&_ul]:pl-6 [&_ul]:my-4 [&_li]:my-1 [&_a]:text-orange-600 [&_a]:underline"
              dangerouslySetInnerHTML={{ __html: post.content_html }}
            />
            <div className="mt-14 bg-slate-950 text-white p-8 rounded-sm">
              <div className="text-xs uppercase tracking-[0.2em] font-bold text-orange-500">Ready to stand out?</div>
              <h2 className="font-display text-2xl font-bold mt-2">Get Platinum 1 Certified. First 2 modules free.</h2>
              <Link to="/register" data-testid="blog-post-cta" className="inline-block mt-5 bg-orange-600 hover:bg-orange-700 px-6 py-3 rounded-sm font-semibold">
                Start free preview
              </Link>
            </div>
          </>
        )}
      </article>
      <SalesChatWidget />
    </div>
  );
}
